<template>
  <v-app v-if="isLoading">
    <loading />
  </v-app>
  <v-col cols="12" class="pa-3" v-else>
    <v-row>
      <v-col cols="12" md="12">
        <v-row v-if="shopRequestsPages.length > 0">
          <v-col cols="12">
            <v-card
              class="EK-card rounded-xl border-top border-right rounded-tr-0 text-center EK-shadow IMTOrange"
            >
              <v-data-table
                dense
                :headers="headers"
                :items="shopRequests"
                :items-per-page="8"
                :page.sync="page"
                @page-count="pageCount = $event"
                hide-default-footer
              >
                <template slot="item.requestDate" slot-scope="{ item }">
                  {{ new Date(item.requestDate).toLocaleString() }}
                </template>

                <template slot="item.details" slot-scope="{ item }">
                  <v-btn
                    color="red"
                    class="ma-2"
                    outlined
                    small
                    fab
                    @click="deleteShop(item)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                  <v-btn
                    :to="'shop-request/details/' + item.id"
                    class="ma-2"
                    outlined
                    small
                    fab
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
              <div class="w-100 pb-10 mt-10">
                <v-pagination
                                color="IMThemeGray"
                                :total-visible="8"
                                v-model="page"
                                :length="pageCount"
                            ></v-pagination>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" lg="4">
            <router-view></router-view>
          </v-col>
        </v-row>

        <v-row v-else class="justify-content-center mt-2">
          <h4>لا يوجد طلبات</h4>
        </v-row>
      </v-col>
    </v-row>
  </v-col>
</template>
<style lang="scss" scoped>
.v-select__selections {
  padding-top: 4px;
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
import loading from "@/components/loading";
import aPagination from "ant-design-vue/lib/pagination";
import Swal from "sweetalert2";

export default {
  components: {
    loading,
    aPagination,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    valid: true,
    menu: false,
    isValidDateRange: false,
    show: false,
    headers: [
      {
        text: "تاريخ الطلب ",
        value: "requestDate",
      },
      {
        text: "اسم المشترك ",
        value: "name",
      },
      {
        text: "رقم الموبايل ",
        value: "mobileNumber",
      },
      {
        text: "المنطقة ",
        value: "areaName",
      },
      {
        text: "الصنف ",
        value: "categoryName",
      },
      {
        text: "التفاصيل ",
        value: "details",
      },
    ],
  }),
  created() {
    this.fetchShopRequests();
    this.setBreadcrumbs([
      {
        text: "طلبات الاشتراك",
      },
    ]);
  },
  computed: {
    ...mapGetters([
      "shopRequests",
      "shopRequestsPages",
      "requestsPageSize",
      "categoriesList",
      "shopTypes",
      "areasList",
      "isLoading",
      "placeholder",
      "domainHost",
      "filterModel",
    ]),
  },
  methods: {
    ...mapActions(["fetchShopRequests", "setBreadcrumbs", "changeShopRequestPage", "removeShop"]),
    nextPage(page) {
      this.page = page;
      this.changeShopRequestPage(page);
    },

    deleteShop(target) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: "هل أنت متأكد؟",
          text: "هل فعلاً تريد حذف المشترك ؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "نعم!",
          cancelButtonText: "إلغاء",
          reverseButtons: false,
        })
        .then((result) => {
          if (result.value) {
            this.SubmitRemoveShop(target);
          }
        });
    },
    SubmitRemoveShop(shopItem) {
      this.removeShop(shopItem);
      this.fetchShopRequests();
      this.$router.push({ name: "shop-request" });
    },
  },
  watch: {
    "filterModel.joinDate"(v) {
      this.isValidDateRange = !(
        v.length == 0 ||
        (!!v && v.length == 2 && new Date(v[1]) > new Date(v[0]))
      );
    },
  },
};
</script>
